<template>


    <v-expansion-panel class="div-11">
      <v-expansion-panel-title>
        <div class="div-12">
          <div class="div-13">
            <div class="text-6">Referentie toevoegen</div>
          </div>
        </div>
      </v-expansion-panel-title>
      <v-expansion-panel-text>
        <v-row>
          <div class="div-14 w-100">
            <div class="field-4">
              <div class="div-15">
                <div class="label">Naam</div>
                <div class="placeholder">-select-</div>
              </div>
              <img loading="lazy"
                   src="/assets/down.svg"
                   class="img"/>
            </div>
            <div class="field-5">
              <div class="label-4">Credential</div>
            </div>
          </div>
          <div class="button-4 mb-3">
            <img loading="lazy"
                 src="/assets/plus.svg"
                 class="img-6"/>
            <div class="button-5">Meer toevoegen</div>
          </div>
        </v-row>
      </v-expansion-panel-text>
    </v-expansion-panel>
</template>

<script lang="ts" setup>

</script>

<style scoped>
.div-11 {
  border-radius: 16px;
  border: 1px solid var(--Neutral-6, #c7c8cc);
  display: flex;
  margin-top: 24px;
  width: 100%;
  flex-direction: column;
  font-family: Montserrat, sans-serif;
  justify-content: start;
}

.div-12 {
  display: flex;
  width: 100%;
  flex-direction: column;
  font-size: 16px;
  color: var(--Neutral-5, #191a1f);
  font-weight: 700;
  line-height: 2;
  justify-content: start;
}

.div-13 {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 8px;
  justify-content: center;
  flex-wrap: wrap;
}

.text-6 {
  align-self: stretch;
  flex: 1;
  flex-basis: 0%;
  margin: auto 0;
}

.div-14 {
  border-radius: 10px;
  border: 0.5px solid var(--Neutral-6, #c7c8cc);
  display: flex;
  margin-top: 24px;
  width: 100%;
  flex-direction: column;
  white-space: nowrap;
  justify-content: start;
  padding: 16px 8px;
}

.field-4 {
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--Neutral-6, #c7c8cc);
  background: var(--Neutral-background, #f7f8fc);
  background-color: var(--Neutral-background, #f7f8fc);
  display: flex;
  min-height: 46px;
  width: 100%;
  gap: 8px;
  justify-content: start;
  flex-wrap: wrap;
  padding: 4px 8px;
}

.div-15 {
  align-self: stretch;
  display: flex;
  min-width: 240px;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  flex-basis: 0%;
  margin: auto 0;
}

.field-5 {
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--Neutral-6, #c7c8cc);
  background: var(--Neutral-background, #f7f8fc);
  background-color: var(--Neutral-background, #f7f8fc);
  display: flex;
  margin-top: 24px;
  min-height: 46px;
  width: 100%;
  gap: 8px;
  font-size: 12px;
  color: var(--Neutral-8, #595c69);
  font-weight: 500;
  line-height: 1;
  justify-content: start;
  padding: 15px 8px;
}

.label-4 {
  align-self: stretch;
  min-width: 240px;
  width: 100%;
  flex: 1;
  margin: auto 0;
}

.button-4 {
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--secondary-secondary, #ff9f1c);
  align-self: start;
  display: flex;
  margin-top: 24px;
  min-height: 24px;
  gap: 4px;
  font-size: 12px;
  color: var(--secondary-secondary, #ff9f1c);
  font-weight: 500;
  line-height: 1;
  width: 136px;
  padding: 4px 8px;
}

.img-6 {
  aspect-ratio: 1;
  object-fit: contain;
  object-position: center;
  width: 16px;
  align-self: stretch;
  margin: auto 0;
}

.button-5 {
  align-self: stretch;
  margin: auto 0;
}

.img {
  aspect-ratio: 1;
  object-fit: contain;
  object-position: center;
  width: 20px;
  align-self: stretch;
  margin: auto 0;
}

@media (max-width: 991px) {
  .div-11,
  .div-12,
  .div-13,
  .text-6,
  .div-14,
  .field-4,
  .div-15,
  .field-5,
  .label-4 {
    max-width: 100%;
    white-space: initial;
  }
}
</style>